/**
 * meta 可配置参数
 * @param {boolean} permission 页面权限
 * @param {boolean} keepAlive 是否缓存页面
 * @param {string} title 页面标题
 **/

import { CONSTS } from "../untils/consts";

import store from "../store/index";

const Index = () => import("../views/index/Index");
const Home = () => import("../views/Home");
//关于我们
const AboutIndex = () => import("../views/about/AboutIndex");
const About = () => import("../views/about/About");
const Contact = () => import("../views/about/Contact");
const Credential = () => import("../views/about/Credential");
const History = () => import("../views/about/History");
const Register = () => import("../components/register/Register");
// const MemberInfo = () => import('../components/register/MemberInfo');
// const TrueName = () => import('../components/register/TrueName');
// const PowerAttorney = () => import('../components/register/PowerAttorney');
// const ElectSeal = () => import('../components/register/ElectSeal');
// const PerfectInfo = () => import('../components/register/PerfectInfo');
const Login = () => import("../components/login/Login");
const FindUpwd = () => import("../components/findupwd/FindUpwd");
const FindPwdVerify = () => import("../components/findupwd/FindPwdVerify");
const FindPwdUser = () => import("../components/findupwd/FindPwdUser");
const ResetPwd = () => import("../components/findupwd/ResetPwd");
const Finance = () => import("../views/finance/Finance");
const FinanceIndex = () => import("../views/finance/FinanceIndex");
const FinanceApply = () => import("../views/finance/FinanceApply");
const FinaAppForm = () => import("../views/finance/FinaAppForm");
const FinaAppSuc = () => import("../views/finance/FinaAppSuc");
const MyFnaDetail = () => import("../views/my/finance/MyFnaDetail");
const FinanceIntention = () => import("../views/finance/FinanceIntention");
const MyIndex = () => import("../views/my/My");
const Identify = () => import("../views/my/identify/Identify");
const Myfanance = () => import("../views/my/finance/Myfanance");
const UserInfo = () => import("../views/my/user/UserInfo");
const AccountSetting = () => import("../views/my/account/AccountSetting");
const BankIndex = () => import("../views/my/bank/BankIndex");
const BankCard = () => import("../views/my/bank/BankCard");
const AddBankCard = () => import("../views/my/bank/AddBankCard");
const BankPayment = () => import("../views/my/bank/Payment");
const EditBank = () => import("../views/my/bank/EditBank");
const ChangeUserInfo = () => import("../views/my/user/ChangeUserInfo");
const ReceiveIndex = () => import("../views/my/AccountReceivable/ReceiveIndex");
const DemandRev = () => import("../views/my/AccountReceivable/DemandRev");
const CoreRevDetail = () =>
  import("../views/my/AccountReceivable/CoreRevDetail");
const DemandDetail = () => import("../views/my/AccountReceivable/DemandDetail");
const CoreRev = () => import("../views/my/AccountReceivable/CoreRev");
//我的还款
const PaybackIndex = () =>
  import(
    /* webpackChunkName: "my-payback" */ "../views/my/payback/PaybackIndex"
  );
const MyPayback = () =>
  import(/* webpackChunkName: "my-payback" */ "../views/my/payback/MyPayback");
const PaybackPlan = () =>
  import(
    /* webpackChunkName: "my-payback" */ "../views/my/payback/PaybackPlan"
  );
const PlanDetails = () =>
  import(/* webpackChunkName: "my-payback" */ "../views/my/payback/PlanDetail");
const PaybackRemain = () =>
  import(
    /* webpackChunkName: "my-payback" */ "../views/my/payback/PaybackRemain"
  );
const RemainDetail = () =>
  import(
    /* webpackChunkName: "my-payback" */ "../views/my/payback/RemainDetail"
  );
const PaybackNotes = () =>
  import(
    /* webpackChunkName: "my-payback" */ "../views/my/payback/PaybackNotes"
  );
const NotesDetail = () =>
  import(
    /* webpackChunkName: "my-payback" */ "../views/my/payback/NotesDetail"
  );
const UnduePlan = () =>
  import(/* webpackChunkName: "my-payback" */ "../views/my/payback/UnduePlan");
const PaybackDetail = () =>
  import(
    /* webpackChunkName: "my-payback" */ "../views/my/payback/PaybackDetail"
  );
const PaybackSuc = () =>
  import(/* webpackChunkName: "my-payback" */ "../views/my/payback/PaybackSuc");
//我的付款
const PayIndex = () =>
  import(/* webpackChunkName: "my-pay" */ "../views/my/pay/PayIndex");
const BuyrePay = () =>
  import(/* webpackChunkName: "my-pay" */ "../views/my/pay/BuyrePay");
const AlreadyPay = () =>
  import(/* webpackChunkName: "my-pay" */ "../views/my/pay/AlreadyPay");
const UnPay = () =>
  import(/* webpackChunkName: "my-pay" */ "../views/my/pay/UnPay");
const PayRemain = () =>
  import(/* webpackChunkName: "my-pay" */ "../views/my/pay/PayRemain");
const PayDetail = () =>
  import(/* webpackChunkName: "my-pay" */ "../views/my/pay/PayDetail");
const AlpayDetail = () =>
  import(/* webpackChunkName: "my-pay" */ "../views/my/pay/AlpayDetail");
const PayRemainDetail = () =>
  import(/* webpackChunkName: "my-pay" */ "../views/my/pay/RemainDetail");
//合同管理
const Agreement = () => import("../views/my/agreement/Agreement");
const AgreementList = () => import("../views/my/agreement/AgreementList"); //待签订
const AgreeDetail = () => import("../views/my/agreement/AgreeDetail"); //签订页面
const AgreeSuc = () => import("../views/my/agreement/AgreeSuc"); //签订成功
const AlAgreeList = () => import("../views/my/agreement/AlAgreeList"); //已签订
const AlAgreeDetail = () => import("../views/my/agreement/AlAgreeDetail"); //已签订详情
const AlAgreeUpload = () => import("../views/my/agreement/AlAgreeUpload"); //已签订详情

const MessageIndex = () => import("../views/my/message/MessageIndex");
const Message = () => import("../views/my/message/Message");
const MsgRead = () => import("../views/my/message/MsgRead");
const File = () => import("../views/my/file/File");
const ChangeTel = () => import("../views/my/account/phone/ChangeTel");
const ChangeSuc = () => import("../views/my/account/phone/ChangeSuc");
const ActiveEmail = () => import("../views/my/account/email/ActiveEmail");
const BundEmail = () => import("../views/my/account/email/BundEmail");
const CheckPwd = () => import("../views/my/account/email/CheckPwd");
const EditEmail = () => import("../views/my/account/email/EditEmail");
const EditPwd = () => import("../views/my/account/pwd/EditPwd");
const EditPwdSuc = () => import("../views/my/account/pwd/EditPwdSuc");
const RetrievePay = () => import("../views/my/account/paypass/RetrievePay");
const ResetPay = () => import("../views/my/account/paypass/ResetPay");
const ChangePay = () => import("../views/my/account/paypass/ChangePay");
const ChangePaySuc = () => import("../views/my/account/paypass/ChangeSuc");
const Investor = () => import("../views/my/account/investor/Investor");
const InvestSuc = () => import("../views/my/account/investor/InvestSuc");
const NewsList = () => import("../views/news/NewsList");
const NewsDetail = () => import("../views/news/NewsDetail");
const ErrorIndex = () => import("../views/error/Error");

export default [
  {
    path: CONSTS.contextPath + "/index.html",
    component: Index,
    name: "Index",
    meta: {
      title: "首页",
    },
    redirect: CONSTS.contextPath + "/index/home.html",
    children: [
      {
        path: CONSTS.contextPath + "/index/home.html",
        name: "Home",
        component: Home,
        meta: {
          title: "首页",
        },
      },
      {
        path: CONSTS.contextPath + "/index/newsList.html",
        name: "NewsList",
        component: NewsList,
        meta: {
          title: "金融动态",
        },
        children: [
          {
            path: CONSTS.contextPath + "/index/newslist/newsdetail.html",
            name: "NewsDetail",
            component: NewsDetail,
            meta: {
              title: "新闻详情",
            },
          },
        ],
      },
      {
        path: CONSTS.contextPath + "/index/aboutindex.html",
        name: "AboutIndex",
        component: AboutIndex,
        meta: {
          title: "关于我们",
        },
        redirect: CONSTS.contextPath + "/index/aboutindex/about.html",
        children: [
          {
            path: CONSTS.contextPath + "/index/aboutindex/about.html",
            component: About,
            name: "About",
            meta: {
              title: "关于我们",
            },
          },
          {
            path: CONSTS.contextPath + "/index/aboutindex/contract.html",
            name: "Contact",
            component: Contact,
            meta: {
              title: "联系我们",
            },
          },
          {
            path: CONSTS.contextPath + "/index/aboutindex/history.html",
            component: History,
            name: "History",
            meta: {
              title: "发展历程",
            },
          },
          {
            path: CONSTS.contextPath + "/index/aboutindex/credential.html",
            component: Credential,
            name: "Credential",
            meta: {
              title: "资质证书",
            },
          },
        ],
      },
      {
        path: CONSTS.contextPath + "/index/finance.html",
        name: "Finance",
        component: Finance,
        meta: {
          title: "我要融资",
        },
        redirect: CONSTS.contextPath + "/index/finance/financeindex.html",
        children: [
          {
            path: CONSTS.contextPath + "/index/finance/financeindex.html",
            name: "FinanceIndex",
            component: FinanceIndex,
            meta: {
              title: "融资首页",
            },
          },
          {
            path: CONSTS.contextPath + "/index/finance/financeapply.html",
            name: "FinanceAply",
            component: FinanceApply,
            meta: {
              title: "融资申请",
              requiresAuth: true,
            },
            redirect:
              CONSTS.contextPath +
              "/index/finance/financeapply/finaappform.html",
            children: [
              {
                path:
                  CONSTS.contextPath +
                  "/index/finance/financeapply/finaappform.html",
                name: "FinaAppForm",
                component: FinaAppForm,
                meta: {
                  title: "提交融资申请",
                },
              },
              {
                path:
                  CONSTS.contextPath +
                  "/index/finance/financeapply/finaappsuc.html",
                name: "FinaAppSuc",
                component: FinaAppSuc,
                meta: {
                  title: "融资申请提交成功",
                },
              },
              {
                path:
                  CONSTS.contextPath +
                  "/index/finance/financeapply/myfinadetail.html",
                name: "MyFnaDetail",
                component: MyFnaDetail,
                meta: {
                  title: "我的融资详情",
                },
              },
            ],
          },
          {
            path: CONSTS.contextPath + "/index/finance/financeintention.html",
            name: "FinanceIntention",
            component: FinanceIntention,
            meta: {
              title: "融资意向",
              requiresAuth: true,
            },
          },
        ],
      },
    ],
  },
  //我的账户
  {
    path: CONSTS.contextPath + "/myindex.html",
    name: "MyIndex",
    component: MyIndex,
    meta: {
      title: "我的账户",
      // requiresAuth: true
    },
    requiresAuth: true,
    redirect: () => {
      const schedule = store.getters.schedule;
      if (schedule < 12) {
        return { path: CONSTS.contextPath + "/myindex/identify.html" };
      } else {
        return { path: CONSTS.contextPath + "/myindex/userinfo.html" };
      }
    },
    children: [
      {
        path: CONSTS.contextPath + "/myindex/identify.html",
        name: "Identify",
        component: Identify,
        meta: {
          title: "认证管理",
        },
      },
      {
        path: CONSTS.contextPath + "/myindex/myfanance.html",
        name: "Myfanance",
        component: Myfanance,
        meta: {
          title: "我的融资",
        },
      },
      {
        path: CONSTS.contextPath + "/myindex/userinfo.html",
        name: "UserInfo",
        component: UserInfo,
        meta: {
          title: "用户信息",
        },
      },
      {
        path: CONSTS.contextPath + "/myindex/accountsetting.html",
        name: "AccountSetting",
        component: AccountSetting,
        meta: {
          title: "账号设置",
        },
      },
      {
        path: CONSTS.contextPath + "/myindex/accountsetting/changetel.html",
        name: "ChangeTel",
        component: ChangeTel,
        meta: {
          title: "修改手机号",
        },
      },
      {
        path: CONSTS.contextPath + "/myindex/accountsetting/changesuc.html",
        name: "ChangeSuc",
        component: ChangeSuc,
        meta: {
          title: "手机号修改成功",
        },
      },
      {
        path: CONSTS.contextPath + "/myindex/accountsetting/CheckPwd.html",
        name: "CheckPwd",
        component: CheckPwd,
        meta: {
          title: "验证密码",
        },
      },
      {
        path: CONSTS.contextPath + "/myindex/accountsetting/BundEmail.html",
        name: "BundEmail",
        component: BundEmail,
        meta: {
          title: "绑定邮箱",
        },
      },
      {
        path: CONSTS.contextPath + "/myindex/accountsetting/ActiveEmail.html",
        name: "ActiveEmail",
        component: ActiveEmail,
        meta: {
          title: "激活邮箱",
        },
      },
      {
        path: CONSTS.contextPath + "/myindex/accountsetting/EditEmail.html",
        name: "EditEmail",
        component: EditEmail,
        meta: {
          title: "填写邮箱",
        },
      },
      {
        path: CONSTS.contextPath + "/myindex/accountsetting/editpwd.html",
        name: "EditPwd",
        component: EditPwd,
        meta: {
          title: "修改密码",
        },
      },
      {
        path: CONSTS.contextPath + "/myindex/accountsetting/editpwdsuc.html",
        name: "EditPwdSuc",
        component: EditPwdSuc,
        meta: {
          title: "修改密码成功",
        },
      },
      {
        path: CONSTS.contextPath + "/myindex/accountsetting/retrievepay.html",
        name: "RetrievePay",
        component: RetrievePay,
        meta: {
          title: "找回支付密码",
        },
      },
      {
        path: CONSTS.contextPath + "/myindex/accountsetting/resetpay.html",
        name: "ResetPay",
        component: ResetPay,
        meta: {
          title: "重置支付密码",
        },
      },
      {
        path: CONSTS.contextPath + "/myindex/accountsetting/changepay.html",
        name: "ChangePay",
        component: ChangePay,
        meta: {
          title: "修改支付密码",
        },
      },
      {
        path: CONSTS.contextPath + "/myindex/accountsetting/changepaysuc.html",
        name: "ChangePaySuc",
        component: ChangePaySuc,
        meta: {
          title: "修改支付密码成功",
        },
      },
      {
        path: CONSTS.contextPath + "/myindex/accountsetting/investor.html",
        name: "Investor",
        component: Investor,
        meta: {
          title: "授权人变更",
        },
      },
      {
        path: CONSTS.contextPath + "/myindex/accountsetting/investorsuc.html",
        name: "InvestorSuc",
        component: InvestSuc,
        meta: {
          title: "授权人变更成功",
        },
      },
      {
        path:
          CONSTS.contextPath + "/myindex/accountsetting/changeuserinfo.html",
        name: "ChangeUserInfo",
        component: ChangeUserInfo,
        meta: {
          title: "变更企业信息",
        },
      },
      {
        path: CONSTS.contextPath + "/myindex/bankindex.html",
        name: "BankIndex",
        component: BankIndex,
        meta: {
          title: "银行卡设置",
        },
        redirect: CONSTS.contextPath + "/myindex/bankindex/bankcard.html",
        children: [
          {
            path: CONSTS.contextPath + "/myindex/bankindex/bankcard.html",
            name: "BankCard",
            component: BankCard,
            meta: {
              title: "银行卡设置",
            },
          },
          {
            path: CONSTS.contextPath + "/myindex/editBank.html",
            name: "EditBank",
            component: EditBank,
            meta: {
              title: "银行卡修改",
            },
          },
          {
            path: CONSTS.contextPath + "/myindex/bankindex/addbankcard.html",
            name: "AddBankCard",
            component: AddBankCard,
            meta: {
              title: "添加银行卡",
            },
          },
          {
            path: CONSTS.contextPath + "/myindex/bankindex/bankpayment.html",
            name: "BankPayment",
            component: BankPayment,
            meta: {
              title: "打款确认",
            },
          },
        ],
      },
      {
        path: CONSTS.contextPath + "/myindex/receiveindex.html",
        name: "ReceiveIndex",
        component: ReceiveIndex,
        meta: {
          title: "应收账款",
        },
        redirect: CONSTS.contextPath + "/myindex/receiveindex/demandrev.html",
        children: [
          {
            path: CONSTS.contextPath + "/myindex/receiveindex/demandrev.html",
            name: "DemandRev",
            component: DemandRev,
            meta: {
              title: "资金需求方信息",
            },
          },
          {
            path: CONSTS.contextPath + "/myindex/receiveindex/corerev.html",
            name: "CoreRev",
            component: CoreRev,
            meta: {
              title: "核心企业",
            },
          },
        ],
      },
      {
        path: CONSTS.contextPath + "/myindex/demanddetail.html",
        name: "DemandDetail",
        component: DemandDetail,
        meta: {
          title: "需求方应收账款详情",
        },
      },
      {
        path: CONSTS.contextPath + "/myindex/corerevdetail.html",
        name: "CoreRevDetail",
        component: CoreRevDetail,
        meta: {
          title: "核心企业应收账款详情",
        },
      },
      {
        path: CONSTS.contextPath + "/myindex/payback.html",
        name: "PaybackIndex",
        component: PaybackIndex,
        redirect: CONSTS.contextPath + "/myindex/payback/mypayback.html",
        meta: {
          title: "我的还款",
        },
        children: [
          {
            path: CONSTS.contextPath + "/myindex/payback/mypayback.html",
            name: "MyPayback",
            component: MyPayback,
            redirect: CONSTS.contextPath + "/myindex/payback/payback-plan.html",
            meta: {
              title: "我的还款",
            },
            children: [
              {
                path: CONSTS.contextPath + "/myindex/payback/payback-plan.html",
                name: "PaybackPlan",
                component: PaybackPlan,
                meta: {
                  title: "我的还款",
                },
              },
              {
                path:
                  CONSTS.contextPath + "/myindex/payback/payback-remain.html",
                name: "PaybackRemain",
                component: PaybackRemain,
                meta: {
                  title: "我的还款",
                },
              },
              {
                path:
                  CONSTS.contextPath + "/myindex/payback/payback-notes.html",
                name: "PaybackNotes",
                component: PaybackNotes,
                meta: {
                  title: "我的还款",
                },
              },
              {
                path: CONSTS.contextPath + "/myindex/payback/uneplan.html",
                name: "UnduePlan",
                component: UnduePlan,
                meta: {
                  title: "我的还款",
                },
              },
            ],
          },
          {
            path: CONSTS.contextPath + "/myindex/payback/plan-detail.html",
            name: "PlanDetails",
            component: PlanDetails,
            meta: {
              title: "我的还款",
            },
          },
          {
            path: CONSTS.contextPath + "/myindex/payback/remain-detail.html",
            name: "RemainDetail",
            component: RemainDetail,
            meta: {
              title: "我的还款",
            },
          },
          {
            path: CONSTS.contextPath + "/myindex/payback/detail.html",
            name: "PaybackDetail",
            component: PaybackDetail,
            meta: {
              title: "我的还款",
            },
          },
          {
            path: CONSTS.contextPath + "/myindex/payback/notes-detail.html",
            name: "NotesDetail",
            component: NotesDetail,
            meta: {
              title: "我的还款",
            },
          },
          {
            path: CONSTS.contextPath + "/myindex/payback/success.html",
            name: "PaybackSuc",
            component: PaybackSuc,
            meta: {
              title: "我的还款",
            },
          },
        ],
      },
      ,
      {
        path: CONSTS.contextPath + "/myindex/pay.html",
        name: "PayIndex",
        component: PayIndex,
        redirect: CONSTS.contextPath + "/myindex/buyrepay.html",
        meta: {
          title: "我的付款",
        },
        children: [
          {
            path: CONSTS.contextPath + "/myindex/buyrepay.html",
            name: "BuyrePay",
            component: BuyrePay,
            redirect: CONSTS.contextPath + "/myindex/pay/unpay.html",
            meta: {
              title: "我的付款",
            },
            children: [
              {
                path: CONSTS.contextPath + "/myindex/pay/already.html",
                name: CONSTS.contextPath + "AlreadyPay",
                component: AlreadyPay,
                meta: {
                  title: "我的付款",
                },
              },
              {
                path: CONSTS.contextPath + "/myindex/pay/unpay.html",
                name: "UnPay",
                component: UnPay,
                meta: {
                  title: "我的付款",
                },
              },
              {
                path: CONSTS.contextPath + "/myindex/pay/remain.html",
                name: "PayRemain",
                component: PayRemain,
                meta: {
                  title: "我的付款",
                },
              },
            ],
          },
          {
            path: CONSTS.contextPath + "/myindex/pay/paydetail.html",
            name: "PayDetail",
            component: PayDetail,
            meta: {
              title: "我的付款",
            },
          },
          {
            path: CONSTS.contextPath + "/myindex/pay/alpaydetail.html",
            name: "AlpayDetail",
            component: AlpayDetail,
            meta: {
              title: "我的付款",
            },
          },
          {
            path: CONSTS.contextPath + "/myindex/pay/payremain-detail.html",
            name: "PayRemainDetail",
            component: PayRemainDetail,
            meta: {
              title: "我的付款",
            },
          },
        ],
      },
      {
        path: CONSTS.contextPath + "/myindex/agreement.html",
        component: Agreement,
        name: "Agreement",
        meta: {
          title: "合同管理",
        },
        redirect: CONSTS.contextPath + "/myindex/agreement/agreementlist.html",
        children: [
          {
            path: CONSTS.contextPath + "/myindex/agreement/agreementlist.html",
            component: AgreementList,
            name: "AgreementList",
            meta: {
              title: "待签订合同",
            },
          },
          {
            path: CONSTS.contextPath + "/myindex/agreement/alagrelist.html",
            component: AlAgreeList,
            name: "AlAgreeList",
            meta: {
              title: "已签订合同",
            },
          },
        ],
      },
      {
        path: CONSTS.contextPath + "/myindex/agreedetail.html",
        component: AgreeDetail,
        name: "AgreeDetail",
        meta: {
          title: "签订合同",
        },
      },
      {
        path: CONSTS.contextPath + "/myindex/agreesuc.html",
        component: AgreeSuc,
        name: "AgreeSuc",
        meta: {
          title: "合同签订成功",
        },
      },
      {
        path: CONSTS.contextPath + "/myindex/alagreedetail.html",
        component: AlAgreeDetail,
        name: "AlAgreeDetail",
        meta: {
          title: "合同详情",
        },
      },
      {
        path: CONSTS.contextPath + "/myindex/alagreeUpload.html",
        component: AlAgreeUpload,
        name: "AlAgreeUpload",
        meta: {
          title: "上传快递单据",
        },
      },
      {
        path: CONSTS.contextPath + "/myindex/messageindex.html",
        component: MessageIndex,
        name: "MessageIndex",
        redirect: CONSTS.contextPath + "/myindex/messageindex/message.html",
        children: [
          {
            path: CONSTS.contextPath + "/myindex/messageindex/message.html",
            component: Message,
            name: "Message",
            meta: {
              title: "消息管理",
            },
          },
          {
            path: CONSTS.contextPath + "/myindex/messageindex/msgread.html",
            component: MsgRead,
            name: "MsgRead",
            meta: "阅读消息",
          },
        ],
      },
      {
        path: CONSTS.contextPath + "/myindex/file.html",
        component: File,
        name: "File",
        meta: {
          title: "文件上传",
        },
      },
    ],
  },
  {
    path: CONSTS.contextPath + "/",
    // name: 'Home',
    component: Index,
    redirect: CONSTS.contextPath + "/index.html",
    // redirect: CONSTS.contextPath + '/index.html',
    // children: [
    //   {
    //     path: CONSTS.contextPath + '/index.html',
    //     name: 'Index',
    //     components: {
    //       default: Index,
    //       // foot: WFooter,
    //     },
    //     meta: {
    //       title: '保理项目'
    //     }
    //   },
    // ]
  },
  {
    path: CONSTS.contextPath + "/register.html",
    name: "Register",
    component: Register,
    meta: {
      title: "注册",
    },
  },
  {
    path: CONSTS.contextPath + "/login.html",
    name: "Login",
    component: Login,
    meta: {
      title: "登录",
    },
  },
  {
    path: CONSTS.contextPath + "/FindUpwd.html",
    name: "FindUpwd",
    component: FindUpwd,
    redirect: CONSTS.contextPath + "/findpwd/user.html",
    children: [
      {
        path: CONSTS.contextPath + "/findpwd/user.html",
        name: "FindPwdUser",
        component: FindPwdUser,
        meta: {
          title: "找回密码",
        },
      },
      {
        path: CONSTS.contextPath + "/findpwd/verify.html",
        name: "FindPwdVerify",
        component: FindPwdVerify,
        meta: {
          title: "找回密码",
        },
      },
      {
        path: CONSTS.contextPath + "/findpwd/reset.html",
        name: "ResetPwd",
        component: ResetPwd,
        meta: {
          title: "重置密码",
        },
      },
    ],
  },
  {
    path: "*",
    name: "ErrorIndex",
    component: ErrorIndex,
    meta: {
      title: "找不到页面",
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/routers.js